import styled from 'styled-components';

export const TextField = styled.input`
  height: 50px;
  width: 20rem;
  padding: 8px;
  background-color: #F3F3F3;
  border: 1px solid #D9D9D9;
  border-radius: 6px;
`;

export const DropdownField = styled.input`
  height: 40px;
  width: 20rem;
  padding: 5px;
  background-color: #F3F3F3;
  border: 1px solid #D9D9D9;
  border-radius: 6px;
`;

export const ValuesField = styled.input`
  padding: 5px;
  background-color: #F3F3F3;
  border: 1px solid #D9D9D9;
  border-radius: 6px;
  transform: scale(1.20)
`;

export const CounterField = styled.input`
  height: 50px;
  width: 20rem;
  padding: 8px;
  background-color: #F3F3F3;
  border: 1px solid #D9D9D9;
  border-radius: 6px;
`;

export const DateField = styled.input`
  height: 50px;
  width: 20rem;
  padding: 8px;
  background-color: #F3F3F3;
  border: 1px solid #D9D9D9;
  border-radius: 6px;
`;

export const FieldTypeTitle = styled.span`
  font-weight: bold;
  font-size: 16px;
  color: #7A7A7A;
`;

export const ItemTitle = styled.span`
  font-weight: bold;
  font-size: 12px;
  color: #7E7E7E;
  margin-bottom: 3px;
`;
